module.exports = __webpack_public_path__ + "img/syetem.69749433.png";